module.exports = __webpack_public_path__ + "static/media/video-17.1cac5337.mp4";